
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("FU6ys", function(module, exports) {

$parcel$export(module.exports, "Env", function () { return $07df59adcab8be84$export$6c0517834721cef7; });
class $07df59adcab8be84$export$6c0517834721cef7 {
    constructor(){
        this.origin = "https://baumkataster-flensburg.de";
        this.contactMail = "oklabflensburg@grain.one";
        this.contactPhone = "+4917659978074";
        this.privacyContactPerson = "David Bornemann";
        this.addressName = "OK Lab Flensburg";
        this.addressStreet = "Am Nordertor";
        this.addressHouseNumber = "2";
        this.addressPostalCode = "24939";
        this.addressCity = "Flensburg";
    }
    injectLinkContent(className, prepend, append, link, value) {
        const nodes = document.querySelectorAll(className);
        nodes.forEach((node)=>{
            node.href = `${prepend}${link}${append}`;
            node.innerHTML = value;
        });
    }
    injectTextContent(className, value) {
        const nodes = document.querySelectorAll(className);
        nodes.forEach((node)=>{
            node.innerText = value;
        });
    }
}

});


var $FU6ys = parcelRequire("FU6ys");
const $635ef2bc860b98f4$var$env = new (0, $FU6ys.Env)();
$635ef2bc860b98f4$var$env.injectLinkContent('.contact-mail', 'mailto:', '', $635ef2bc860b98f4$var$env.contactMail, $635ef2bc860b98f4$var$env.contactMail);
$635ef2bc860b98f4$var$env.injectLinkContent('.contact-phone', 'tel:', '', $635ef2bc860b98f4$var$env.contactPhone, $635ef2bc860b98f4$var$env.contactPhone);
$635ef2bc860b98f4$var$env.injectLinkContent('.matomo-disagree', '', '/index.php?module=CoreAdminHome&action=optOut&language=de', $635ef2bc860b98f4$var$env.origin, 'Hakens');
$635ef2bc860b98f4$var$env.injectLinkContent('.website-origin', '', '', '', $635ef2bc860b98f4$var$env.origin);
$635ef2bc860b98f4$var$env.injectTextContent('.privacy-contact-person', $635ef2bc860b98f4$var$env.privacyContactPerson);
$635ef2bc860b98f4$var$env.injectTextContent('.address-name', $635ef2bc860b98f4$var$env.addressName);
$635ef2bc860b98f4$var$env.injectTextContent('.address-street', $635ef2bc860b98f4$var$env.addressStreet);
$635ef2bc860b98f4$var$env.injectTextContent('.address-house-number', $635ef2bc860b98f4$var$env.addressHouseNumber);
$635ef2bc860b98f4$var$env.injectTextContent('.address-postal-code', $635ef2bc860b98f4$var$env.addressPostalCode);
$635ef2bc860b98f4$var$env.injectTextContent('.address-city', $635ef2bc860b98f4$var$env.addressCity);


//# sourceMappingURL=impressum.17099df2.js.map
